const Timings = {
  EVENT_PROCESSING_DELAY: 100,
  FAVICON_DELAY: 100,
  IDLE_CALLBACK_TIMEOUT: 3000,
};

export default Timings;
